export default __webpack_public_path__ + "static/media/HomeBack.46836e5a.svg";